export const VISTORIA = () => `/vistoria`;
export const VISTORIA_CAPTURA = () => `/vistoria/captura`;
export const VISTORIA_CHECKLIST_ACESSORIOS = () => `/vistoria/checklist-acessorios`;

/**
 * A assinatura do associado na VISTORIA e a prévia do laudo (at-64, frente D/D2).
 *
 * 🔴 **Antes eram `/assinatura-termo` e `/assinatura-termo/visualizar`** —
 * literais espalhados por 6 arquivos, com nome de outra coisa. São etapas do
 * fluxo de vistoria: a primeira grava em `POST /vistorias/:id/signature` e segue
 * para o laudo; a segunda mostra o laudo antes de assinar. O nome vinha de uma
 * época em que se pensava em "termo", e custava caro: `rotasComShell.ts` e
 * `routes.test.ts` precisavam de sentinelas explicando que `/assinatura` (a
 * assinatura do CONTRATO, outro fluxo) não as capturava.
 *
 * ⚠️ **Nenhum link externo aponta para elas** — a assinatura só é alcançada de
 * dentro do fluxo, com `location.state`. Não havia bookmark a preservar.
 *
 * 📌 Com o rename, a família `/vistoria` passou a cobrir as 7 telas por prefixo, e
 * o "modo de casamento exato" que a at-63 criou em `rotasComShell` ficou sem uso.
 */
export const VISTORIA_ASSINATURA = () => `/vistoria/assinatura`;
export const VISTORIA_ASSINATURA_PREVIA = () => `/vistoria/assinatura/previa`;

export const VISTORIA_LAUDO = () => `/vistoria/laudo`;
export const VISTORIA_LAUDO_HTML_VEICULO = (vehicleId: string = ':vehicleId') =>
	`/vistoria/veiculo/${vehicleId}/laudo`;
